<template>
	<main class="main">
		<div class="main__page">
			<div class="card__header">
				<h2 class="main-title">
					{{$t('checksheet.title')}}
				</h2>
				<button class="btn" @click="showNewModal">
					{{ $t('common.new.title') }}
				</button>
			</div>
			<div class="card">
				<div class="card__detail">
					<form class="form" @submit.prevent="submitForm">
						<input type="hidden" v-model.trim="$v.form.user_id.$model">
						<input type="hidden" v-model.trim="$v.form.customer_id.$model">
						<div class="wizard_form">
							<div class="navigation_wizard">
								<div class="nav__step" v-for="step in 6" :id="`step${step}`">
									<button class="step" @click="goStep(step)" type="button"
											:disabled="currentStep < step"
											v-bind:class="[{'inactive': currentStep > step}, {'current': currentStep == step}]">
										{{ $t(`checksheet.steps.step${step}.title`)}}
									</button>
								</div>
							</div>
							<div class="steps">
								<!--
								***** STEP 1 *****
								** DATI CLIENTE **
								******************
								-->
								<div class="step" id="step1_form" v-show="currentStep == 1">
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.contratto')}}</label>
										<input class="form__field-input" v-model.trim="$v.form.contratto.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.data_controllo')}}</label>
										<input type="date" class="form__field-input"
											   v-model.trim="$v.form.data_controllo.$model"/>
										<div class="field__validator_error" v-bind:class="{'submitted': 'show'}"
											 v-if="submitted && !$v.form.data_controllo.required">
											{{ $t('checksheet.errors.data_controllo_required') }}
										</div>
									</div>
									<h2 class="title">{{$t('checksheet.steps.step1.subtitle')}}</h2>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.customer.agency')}}</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.agency.$model"/>
										<div class="field__validator_error"
											 v-if="submitted && !$v.form.customer.agency.required">
											{{ $t('checksheet.errors.customer.agency_required') }}
										</div>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.customer.first_name')}}</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.first_name.$model"/>
										<div class="field__validator_error"
											 v-if="submitted && !$v.form.customer.first_name.required">
											{{ $t('checksheet.errors.customer.first_name_required') }}
										</div>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.customer.last_name')}}</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.last_name.$model"/>
										<div class="field__validator_error"
											 v-if="submitted && !$v.form.customer.last_name.required">
											{{ $t('checksheet.errors.customer.last_name_required') }}
										</div>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.customer.address')}}</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.address.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.customer.city')}}</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.city.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.customer.vat_number')}}</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.vat_number.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.customer.email')}}</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.email.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.customer.email')}}
											2</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.email2.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.customer.email')}}
											3</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.email3.$model"/>
									</div>

									<div class="form__field">
										<label class="form__field-label">Indirizzo sede</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.sedi.indirizzo.$model"/>
									</div>

									<div class="form__field">
										<label class="form__field-label">Luogo sede</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.sedi.luogo.$model"/>
									</div>


									<div class="controls-btns">
										<button class="btn light" @click="selectCustomer()" type="button">{{
											$t('checksheet.form.customer.btn_seleziona_cliente') }}
										</button>
										<button class="btn" @click="nextStep()" type="button">{{ $t('common.next') }}
										</button>
									</div>
									<select-customer v-model="modalSelectClienteOpen"
													 @result="updateCustomerData($event)"></select-customer>
								</div>
								<!--
							   ***** STEP 2 *****
							   -->
								<div class="step" id="step2_form" v-show="currentStep == 2">
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.kg')}}</label>
										<input type="number" class="form__field-input"
											   v-model.trim="$v.form.kg.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.matricola')}}</label>
										<input class="form__field-input" v-model.trim="$v.form.matricola.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.scadenza_collaudi')}}</label>
										<input type="date" class="form__field-input"
											   v-model.trim="$v.form.scadenza_collaudi.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.ubicazione')}}</label>
										<input maxlength="15" class="form__field-input"
											   v-model.trim="$v.form.ubicazione.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.protezione_macchina')}}</label>
										<input class="form__field-input"
											   v-model.trim="$v.form.protezione_macchina.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.affilatrice')}}</label>
										<input class="form__field-input" v-model.trim="$v.form.affilatrice.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.matricola_2')}}</label>
										<input class="form__field-input" v-model.trim="$v.form.matricola_2.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('checksheet.form.tipo_centrale')}}</label>
										<input class="form__field-input" v-model.trim="$v.form.tipo_centrale.$model"/>
									</div>
									<div class="controls-btns">
										<button class="btn light" @click="prevStep()" type="button">{{ $t('common.back')
											}}
										</button>
										<button class="btn" @click="nextStep()" type="button">{{ $t('common.next') }}
										</button>
									</div>
								</div>
								<!--
							   ***** STEP 3 *****
							   -->
								<div class="step" id="step3_form" v-show="currentStep == 3">
									<h2 class="options__title">{{$t('checksheet.steps.step3.subtitle')}}</h2>
									<div class="options" v-for="(item, index) in form.d3"
										 v-if="index.substr(0, 1) == 'a'">
                                        <span class="options__label">
                                            {{$t(`checksheet.form.d3.${index}`)}}
                                        </span>
										<span class="options__choices">
                                            <label class="options__choices-item"
												   v-bind:class="{'checked': `_${form.d3[index]}` == '_1'}"
												   :for="`d3${index}_1`">
                                                <input type="radio" :id="`d3${index}_1`" :name="`d3${index}`"
													   class="form__field-input" v-model.trim="$v.form.d3[index].$model"
													   value="1"/>
                                                <span class="label">{{ $t(`common.radiooptions.positive`)}}</span>
                                            </label>
                                            <label class="options__choices-item"
												   v-bind:class="{'checked': `_${form.d3[index]}` == '_0'}"
												   :for="`d3${index}_2`">
                                                <input type="radio" :id="`d3${index}_2`" :name="`d3${index}`"
													   class="form__field-input" v-model.trim="$v.form.d3[index].$model"
													   value="0"/>
                                                <span class="label">{{ $t(`common.radiooptions.negative`)}}</span>
                                            </label>
                                            <label class="options__choices-item"
												   v-bind:class="{'checked': `_${form.d3[index]}` == '_'}"
												   :for="`d3${index}_3`">
                                                <input type="radio" :id="`d3${index}_3`" :name="`d3${index}`"
													   class="form__field-input" v-model.trim="$v.form.d3[index].$model"
													   value=""/>
                                                <span class="label">{{ $t(`common.radiooptions.na`)}}</span>
                                            </label>
                                        </span>
									</div>
									<h2 class="options__title">{{$t('checksheet.steps.step3.subtitle2')}}</h2>
									<div class="options" v-for="(item, index) in form.d3"
										 v-if="index.substr(0, 1) == 'b'">
                                        <span class="options__label">
                                            {{$t(`checksheet.form.d3.${index}`)}}
                                        </span>
										<span class="options__choices">
                                            <label class="options__choices-item"
												   v-bind:class="{'checked': `_${form.d3[index]}` == '_1'}"
												   :for="`d3${index}_1`">
                                                <input type="radio" :id="`d3${index}_1`" :name="`d3${index}`"
													   class="form__field-input" v-model.trim="$v.form.d3[index].$model"
													   value="1"/>
                                                <span class="label">{{ $t(`common.radiooptions.positive`)}}</span>
                                            </label>
                                            <label class="options__choices-item"
												   v-bind:class="{'checked': `_${form.d3[index]}` == '_0'}"
												   :for="`d3${index}_2`">
                                                <input type="radio" :id="`d3${index}_2`" :name="`d3${index}`"
													   class="form__field-input" v-model.trim="$v.form.d3[index].$model"
													   value="0"/>
                                                <span class="label">{{ $t(`common.radiooptions.negative`)}}</span>
                                            </label>
                                            <label class="options__choices-item"
												   v-bind:class="{'checked': `_${form.d3[index]}` == '_'}"
												   :for="`d3${index}_3`">
                                                <input type="radio" :id="`d3${index}_3`" :name="`d3${index}`"
													   class="form__field-input" v-model.trim="$v.form.d3[index].$model"
													   value=""/>
                                                <span class="label">{{ $t(`common.radiooptions.na`)}}</span>
                                            </label>
                                        </span>
									</div>
									<div class="controls-btns">
										<button class="btn light" @click="prevStep()" type="button">{{ $t('common.back')
											}}
										</button>
										<button class="btn" @click="nextStep()" type="button">{{ $t('common.next') }}
										</button>
									</div>
								</div>
								<!--
							   ***** STEP 4 *****
							   -->
								<div class="step" id="step4_form" v-show="currentStep == 4">
									<div class="form__field notefield">
										<label class="form__field-label">{{$t('checksheet.form.d3.note')}}</label>
										<input maxlength="150" class="form__field-input"
											   v-model.trim="$v.form.d3.note.$model"></input>
									</div>
									<div class="form__field yesnofield">
										<label class="form__field-label">{{$t('checksheet.form.antincendio')}}</label>
										<label class="yesno" v-bind:class="{'checked' : form.antincendio }" for="yesno">
											<span class="option yes">Si</span>
											<span class="option no">No</span>
											<input type="checkbox" id="yesno" class="form__field-input"
												   v-model.trim="$v.form.antincendio.$model"/>
										</label>
									</div>
									<div class="controls-btns">
										<button class="btn light" @click="prevStep()" type="button">{{ $t('common.back')
											}}
										</button>
										<button class="btn" @click="nextStep()" type="button">{{ $t('common.next') }}
										</button>
									</div>
								</div>
								<!--
							   ***** STEP 5 *****
							   -->
								<div class="step" id="step5_form" v-show="currentStep == 5">
									<div class="options" v-for="index in 12">
										<span class="options__label">{{$t(`checksheet.form.d4_${index}`)}}</span>
										<span class="options__choices">
                                            <label class="options__choices-item"
												   v-bind:class="{'checked': `_${form[`d4_${index}`]}` == '_1' }"
												   :for="`d4_${index}_1`">
                                                <input type="radio" :id="`d4_${index}_1`" :name="`d4_${index}`"
													   class="form__field-input"
													   v-model.trim="$v.form[`d4_${index}`].$model" value="1"/>
                                                <span class="label">{{ $t(`common.radiooptions.positive`) }}</span>
                                            </label>
                                            <label class="options__choices-item"
												   v-bind:class="{'checked': `_${form[`d4_${index}`]}` == '_0' }"
												   :for="`d4_${index}_2`">
                                                <input type="radio" :id="`d4_${index}_2`" :name="`d4_${index}`"
													   class="form__field-input"
													   v-model.trim="$v.form[`d4_${index}`].$model" value="0"/>
                                                <span class="label">{{ $t(`common.radiooptions.negative`) }}</span>
                                            </label>
                                            <label class="options__choices-item"
												   v-bind:class="{'checked': `_${form[`d4_${index}`]}` == '_' }"
												   :for="`d4_${index}_3`">
                                                <input type="radio" :id="`d4_${index}_3`" :name="`d4_${index}`"
													   class="form__field-input"
													   v-model.trim="$v.form[`d4_${index}`].$model" value=""/>
                                                <span class="label">{{ $t(`common.radiooptions.na`) }}</span>
                                            </label>
                                        </span>
									</div>
									<div class="controls-btns">
										<button class="btn light" @click="prevStep()" type="button">{{ $t('common.back')
											}}
										</button>
										<button class="btn" @click="nextStep()" type="button">{{ $t('common.next') }}
										</button>
									</div>
								</div>
								<!--
							   ***** STEP 6 *****
							   -->
								<div class="step" id="step6_form" v-show="currentStep == 6">
									<preview-data ref="preview" :structure="preview_structure"
												  :items="form"></preview-data>
									<div class="controls-btns">
										<button class="btn light" @click="prevStep()" type="button" :disabled="loading">
											{{ $t('common.back') }}
										</button>
										<button class="btn" @click="showSaveModal()" type="button" :disabled="loading">

											<span v-if="loading">{{ $t('common.loading') }}</span> <span
												v-if="!loading">
                                                <span>{{ $t('common.save') }}</span>
                                            </span>
										</button>
										<button class="btn" @click="openSignature()" type="button" :disabled="loading">
											<span v-if="loading">{{ $t('common.loading') }}</span> <span
												v-if="!loading">
                                                <span>{{ $t('common.saveAndSign') }}</span>
                                            </span>
										</button>
									</div>
									<signature-pad v-model="modalSignatureOpen"
												   @result="updateSignatureStatus($event)"></signature-pad>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
		<confirm-modal v-model="modalNew" v-bind:title="$t('common.new.title')" v-bind:text="$t('common.new.message')"
					   @result="closeNewModal($event)"></confirm-modal>
		<confirm-modal v-model="modalSave" v-bind:title="$t('common.saveData.title')"
					   v-bind:text="$t('common.saveData.message')" @result="closeSaveModal($event)"></confirm-modal>
	</main>

</template>
<script>
    import {required} from 'vuelidate/lib/validators'
    import AlertModal from "../../components/AlertModal"
    import ConfirmModal from "../../components/ConfirmModal"
    import SelectCustomer from "../../components/SelectCustomerModal";
    import PreviewData from "../../components/AnteprimaComponent";
    import SignaturePad from "../../components/SignaturePadComponent";
    import moment from "moment-timezone";

    export default {
        name: 'check_sheet_wizard_form',
        components: {
            SignaturePad,
            PreviewData,
            SelectCustomer,
            AlertModal,
            ConfirmModal
        },
        mounted() {
            this.preview_structure = this.api.checksheets.structureDoc;
            this.init();
        },
        data() {
            return {
                submitted: false,
                user: null,
                showError: false,
                error: '',
                loading: false,
                currentStep: 1,
                modalSelectClienteOpen: false,
                modalSignatureOpen: false,
                preview_structure: [],
                form: {},
                modalNew: false,
                modalSave: false,
            }
        },
        watch: {
            'form': {
                handler() {
                    // salvo il dato
                    this.sync.tempData.update('checksheet', this.form);
                },
                deep: true
            },
        },
        // gestione della validazione
        validations: {
            form: {
                user_id: {
                    required
                },
                customer_id: {},
                contratto: {},
                data_controllo: {
                    required
                },
                customer: {
                    agency: {
                        required
                    },
                    first_name: {
                        required
                    },
                    last_name: {
                        required
                    },
                    address: {},
                    city: {},
                    vat_number: {},
                    email: {},
                    email2: {},
                    email3: {},
                    sedi: {
                        indirizzo: {},
                        luogo: {}
                    }
                },
                kg: {},
                matricola: {},
                scadenza_collaudi: {},
                ubicazione: {},
                protezione_macchina: {},
                affilatrice: {},
                matricola_2: {},
                tipo_centrale: {},
                d3: {
                    a1: {},
                    a2: {},
                    a3: {},
                    b1: {},
                    b2: {},
                    b3: {},
                    b4: {},
                    b5: {},
                    b6: {},
                    note: {},
                },
                antincendio: {},
                d4_1: {},
                d4_2: {},
                d4_3: {},
                d4_4: {},
                d4_5: {},
                d4_6: {},
                d4_7: {},
                d4_8: {},
                d4_9: {},
                d4_10: {},
                d4_11: {},
                d4_12: {},
                signature: {},
				sede: {}
            }
        },
        methods: {
            init() {
                this.initForm();
                this.sync.tempData.get('checksheet')
                    .then((data) => {
                        if (data !== null) {
                            this.form = data;
                        }
                    });
            },
            initForm() {
                this.form = {
                    user_id: localStorage.getItem('user_id') || '',
                    customer_id: '',
                    contratto: '',
                    data_controllo: moment().format("YYYY-MM-DD"),
                    customer: {
                        agency: '',
                        first_name: '',
                        last_name: '',
                        address: '',
                        city: '',
                        vat_number: '',
                        email: '',
                        email2: '',
                        email3: '',
                        sedi: {
                            indirizzo: '',
                            luogo: ''
                        }
                    },
                    kg: '',
                    matricola: '',
                    scadenza_collaudi: null,
                    ubicazione: '',
                    protezione_macchina: '',
                    affilatrice: '',
                    matricola_2: '',
                    tipo_centrale: '',
                    d3: {
                        a1: "",
                        a2: "",
                        a3: "",
                        b1: "",
                        b2: "",
                        b3: "",
                        b4: "",
                        b5: "",
                        b6: "",
                        note: ""
                    },
                    antincendio: 0,
                    d4_1: "",
                    d4_2: "",
                    d4_3: "",
                    d4_4: "",
                    d4_5: "",
                    d4_6: "",
                    d4_7: "",
                    d4_8: "",
                    d4_9: "",
                    d4_10: "",
                    d4_11: "",
                    d4_12: "",
                    signature: "",
					sede: null
                };
            },
            showNewModal() {
                this.modalNew = !this.modalNew;
            },
            closeNewModal(res) {
                if (res) {
                    this.form = {};
                    this.initForm();
                    this.goStep(1);
                }
            },
            showSaveModal() {
                this.modalSave = !this.modalSave;
            },
            closeSaveModal(res) {
                if (res) {
                    this.sync.tempData.addItem('checksheet', this.form);
                    alert(`Elemento salvato con successo`);
                    this.$router.push({path: '/'});
                }
            },
            nextStep() {
                this.submitted = true;
                if (!this.$v.$invalid) {
                    this.currentStep++;
                    this.$refs.preview.updateCells();
                } else {
                    alert('Errore, controllare i dati prima di procedere.');
                }
            },
            prevStep() {
                if (this.currentStep > 1)
                    this.currentStep -= 1;
                this.$refs.preview.updateCells();
            },
            goStep(step) {
                this.currentStep = step;
                this.$refs.preview.updateCells();
            },
            /** Apre la modale per la selezione del customer */
            selectCustomer() {
                this.modalSelectClienteOpen = !this.modalSelectClienteOpen;
            },
            /** Apre la firma per la chiusura del modulo */
            openSignature() {
                this.modalSignatureOpen = !this.modalSignatureOpen;
            },
            /** Eseguita la firma mi metto, salvo la form */
            updateSignatureStatus(data) {
                if (data !== false) {
                    this.form.signature = data;
                    this.submitForm();
                }
            },
            /** Sistemazione del customer */
            updateCustomerData(data) {
                this.form.customer_id = '';
                this.form.customer.agency = '';
                this.form.customer.first_name = '';
                this.form.customer.last_name = '';
                this.form.customer.address = '';
                this.form.customer.city = '';
                this.form.customer.vat_number = '';
                this.form.customer.email = '';
                this.form.customer.email2 = '';
                this.form.customer.email3 = '';
                this.form.customer.sedi = {
                    indirizzo: "",
                    luogo: ""
                };
                if (data && data !== false && data !== null) {
                    this.form.customer_id = data.id;
                    this.form.customer.agency = data.agency;
                    this.form.customer.first_name = data.first_name;
                    this.form.customer.last_name = data.last_name;
                    this.form.customer.address = data.address;
                    this.form.customer.city = data.city;
                    this.form.customer.vat_number = data.vat_number;
                    this.form.customer.email = data.email;
                    this.form.customer.email2 = data.email2;
                    this.form.customer.email3 = data.email3;
                    this.form.customer.sedi = data.sedi;
                }
                this.form.sede = {...this.form.customer.sedi};
            },
            /** Salvo i dati */
            saveData(frm) {

                // salvo offline
                frm.id = this.helpers.generateNewUUID();
                frm.updated_at = frm.created_at = moment().tz("Europe/Rome").format("YYYY-MM-DD kk:mm:ss");
                frm.deleted_at = null;
                delete frm.data_salvataggio;
				// salvo nella lista dei rapporti di intervento salvati
                this.sync.tempData.addItem('checksheet', this.form);
                this.api.checksheets.offline.add(frm)
                    .then((checksheet_id) => {
                        // se è tutto ok, procedo con la sincronizzazione
                        if (navigator.onLine) {
                            this.sync.syncronizeTable('customers', (updated, params) => {
                                if (updated == 'end') {
                                    this.sync.syncronizeTable('check_sheets', (updated, params) => {
                                        this.initForm();
                                        if (updated == 'end') {
                                            this.toast.success(this.$t(`checksheet.save_complete`));
                                            this.$router.push({path: '/'});
                                        }
                                        if (updated == 'error') {
                                            // fine sincronizzazione
                                            this.toast.info(this.$t(`checksheet.save_without_sync`));
                                            this.$router.push({path: '/'});
                                        }
                                    });
                                }
                            });
                        } else {
                            this.sync.tempData.remove('checksheet');
                            this.toast.info('Nessuna connessione internet. Il report sarà inviato alla prossima sincronizzazione.');
                            this.$router.push({path: '/'});
                            this.loading = false;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            /** Invio la form */
            submitForm() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.loading = true;
                    // sistemazione della form
                    let frm = {...this.form};
                    frm.antincendio = (this.form.antincendio == true) ? 1 : 0;
                    Object.keys(frm.d3).forEach((key) => {
                        if (key !== 'note')
                            if (frm.d3[key] !== "")
                                frm[`d3_${key}`] = +frm.d3[key];
                            else
                                frm[`d3_${key}`] = null;
                        else
                            frm[`d3_${key}`] = frm.d3[key];
                    });
                    Object.keys(frm).forEach((key) => {
                        // sistemo i d4
                        if (key.substr(0, 3) == "d4_" && frm[key] !== "") {
                            frm[key] = +frm[key];
                        } else {
                            if (key.substr(0, 3) == "d4_" && frm[key] == "") {
                                frm[key] = null
                            }
                        }
                    });
                    delete frm.d3;
                    frm.sede = {...frm.customer.sedi};
                    // controllo se esiste il customer_id
                    // se non esiste creo il dato nel database
                    if (frm.customer_id.trim() == "") {
                        let c = {...frm.customer};
                        c.id = this.helpers.generateNewUUID();
                        c.updated_at = c.created_at = moment().tz("Europe/Rome").format("YYYY-MM-DD kk:mm:ss");
                        c.deleted_at = null;
                        let aT = [];
                        aT.push(c.sedi);
                        c.sedi = aT;
                        this.api.customers.offline.add(c)
                            .then((customer_id) => {
                                frm.customer_id = customer_id;
                                delete frm.customer;
                                this.saveData(frm);
                            })
                            .catch((err) => {
                                // TODO: Sistemare l'errore
                                console.log(err);
                            })
                    } else {
                        delete frm.customer;
                        this.saveData(frm);
                    }
                } else {
                    this.loading = false;
                }
                /*this.$v.$touch();
                this.submitted = true;
                this.error = '';
                this.loading = true;
                // controllo la validità della form
                // ci sarà un controllo anche lato server
                if (!this.$v.$invalid) {
                    this.loading = true;
                    this.api.users.save(this.form, this.$route.params.id)
                        .then(() => {
                            this.toast.success();
                            this.$router.push({ path: '/users' });
                        })
                        .catch((e) => {
                            this.toast.error(this.$t(`users.errors.${e.error}`));
                        })
                        .finally(() => {
                            this.loading = false;
                        })
                } else {
                    this.loading = false;
                }*/
            }
        }
    }
</script>
<style lang="scss">
	@import './src/scss/variables';
	@import './src/scss/checksheet';
	@import './src/scss/form';
</style>
